import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FeatureFlagService } from '@headpower/featureflags';
import { AppConfig } from '../../app.config';
import { Observable, of } from 'rxjs';
import { catchError, map, pluck } from 'rxjs/operators';

/**
 * Company Task Types
 */
export class TaskTypes {
    Id: string;
    CompanyId?: string;
    TaskType: string;

    TranslatedName: string;

    translatedValue?: string;

    constructor(type: string = null) {
        this.TaskType = type;
    }
}

@Injectable()
export class TaskTypeService {

    private backendUri = this.config.backendIwmUri + 'Api/';
    private customerAdminUri = this.config.backendIwmUri + 'CustomerAdminApi/';
    private headpowerAdminUri = this.config.backendIwmUri + 'HeadPowerAdminApi/';

    private getListItemsByTypeAndTaskType = `ListItems/Default.GetListItemsByTypeAndTaskType(type=HeadPower.Iwm.Objects.Enum.ListType'TaskSubtype',taskType=HeadPower.Iwm.Objects.Enum.TaskType'{0}',companyId={1})`;

    constructor(private featureFlagService: FeatureFlagService,
        private http: HttpClient,
        private config: AppConfig) {
    }

    /***
     *  ALL Customer methods
     */

    public getTaskTypes(): Observable<Array<string>> {
        return this.http.get<Array<TaskTypes>>(`${this.backendUri}` + `CompanyTaskTypeVisibility`)
            .pipe(
                map(res => {
                    let types: string[] = [];
                    if (res) {
                        res['value'].forEach(element => {
                            types.push(element.TaskType);
                        });
                    }
                    return types;
                })
            );
    }


    public getSubTaskTypesForCompany(taskType: string, companyId: string): Observable<SubTypeODataResult> {
        const url = this.customerAdminUri + this.getListItemsByTypeAndTaskType.replace('{0}', taskType).replace('{1}', companyId);
        return this.http.get<SubTypeODataResult>(url);
    }



    /***
     *  ALL Admin methods
     */

    public getTaskTypesForCompany(companyId: string): Observable<{ value: TaskTypes[] }> {
        const url = `${this.headpowerAdminUri}` + `CompanyTaskTypeVisibility/Default.GetTaskTypesForCompany(companyId=${companyId})`;
        return this.http.get<{ value: TaskTypes[] }>(url);
    }


    public getTaskTypesAllowedForPartner(): Observable<any> {
        const url = `${this.customerAdminUri}` + `TaskCreationPermission/Default.GetTaskCreationPermissionTypesWhereWeArePartner()`;
        return this.http.get<any>(url);
    }

    public getAllTaskTypes(): Observable<Array<string>> {
        const url = `${this.headpowerAdminUri}` + `CompanyTaskTypeVisibility/Default.GetAllTaskTypes()`;
        return this.http.get<Array<string>>(url)
            .pipe(pluck('value') as any);
    }

    public addTaskTypeForCompany(taskType: string, companyId: string): Observable<any> {

        const url = this.headpowerAdminUri + 'CompanyTaskTypeVisibility';

        const message = {
            Id: '00000000-0000-0000-0000-000000000000',
            CompanyId: companyId,
            TaskType: taskType
        };

        return this.http
            .post(url, message).pipe(
                map((res: Response) => {
                    const status = res.status;
                    if (status === 201) {
                        return true;
                    } else {
                        return false;
                    }
                }));
    }

    /**
     * Delete company from task companies
     * @param {string} taskCompanyId company id
     * @returns {Observable<boolean>} Success/failure
     */
    public removeTaskTypeForCompany(id: string): Observable<boolean> {
        const url = this.headpowerAdminUri + `CompanyTaskTypeVisibility(${id})`;
        return this.http
            .delete(url).pipe(
                map(() => {
                    return true;
                }), catchError((error: any) => {
                    console.log(error);
                    return of(false);
                }));
    }

}

export class SubTypeODataResult {
    public context: string;
    public value: Array<SelectionDto>
}

export class SelectionDto {
    public Value: string;
}
